import React from "react"
import { Trans } from "react-i18next"
import DivContentLoader from "../../Component/DivContentLoader"

const KOLInsightsLoading = () => {
  return (
    <div className="w-full md:pt-2 pt-6 md:grid grid-cols-1 lg:grid-cols-2 md:gap-4 md:px-0 px-4">
      <section className="w-full mb-8 ">
        <div className="grid grid-cols-4 mb-4">
          <div className="col-span-1">
            <div className="w-16 h-16 rounded-full">
              <DivContentLoader w={50} h={50} r={100} />
            </div>
          </div>
          <div className={"grid grid-cols-3 col-span-3"}>
            <div className={"text-center my-auto"}>
              <p className={"text-lg font-semibold"}>
                <DivContentLoader w={15} h={20} r={8} />
              </p>
              <h3 className="text-sm text-gray-500 font-normal">
                <Trans>SignUp.posts</Trans>
              </h3>
            </div>
            <div className={"text-center  my-auto"}>
              <p className={"text-lg font-semibold"}>
                <DivContentLoader w={15} h={20} r={8} />
              </p>
              <h3 className="text-sm text-gray-500 font-normal">
                <Trans>SignUp.followers</Trans>
              </h3>
            </div>
            <div className={"text-center  my-auto"}>
              <p className={"text-lg font-semibold"}>
                <DivContentLoader w={15} h={20} r={8} />
              </p>
              <h3 className="text-sm text-gray-500 font-normal">
                <Trans>SignUp.following</Trans>
              </h3>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <h2 className="text-2xl text-left font-medium text-red-default">
          <Trans>LocationEditRow.title</Trans>
        </h2>

        <div className="my-2">
          <DivContentLoader w={300} h={200} r={20} />
        </div>
      </section>

      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <h2 className="text-2xl text-left font-medium  text-red-default">
          <Trans>GenderEditRow.title</Trans>
        </h2>

        <div className="my-2">
          <DivContentLoader w={300} h={200} r={20} />
        </div>
      </section>

      <section className="w-full my-4 pl-4 text-left border-l-4 border-red-300">
        <h2 className="text-2xl text-left font-medium  text-red-default">
          <Trans>AgeGroupEditRow.title</Trans>
        </h2>
        <div className="my-2">
          <DivContentLoader w={300} h={200} r={20} />
        </div>
      </section>
    </div>
  )
}

export default KOLInsightsLoading
